import React from 'react';
import { CaptureSequence } from './types';

interface GhostOverlayProps {
  view: CaptureSequence;
  opacity?: number;
}

const GhostOverlay: React.FC<GhostOverlayProps> = ({ view, opacity = 0.3 }) => {
  const isLateral = view === 'Left' || view === 'Right';

  return (
    <div className="absolute inset-0 pointer-events-none flex items-center justify-center" style={{ opacity }}>
      <svg
        viewBox="0 0 200 400"
        fill="none"
        stroke="white"
        strokeWidth="2"
        strokeDasharray="4 4"
        className="h-5/6 w-auto opacity-50"
      >
        {isLateral ? (
          // Generic Lateral Outline
          <path d="M100,30 C115,30 125,45 120,60 C115,75 110,80 115,90 C125,110 120,150 115,180 L110,280 L120,380 M100,30 C85,30 75,45 80,60 C85,75 90,80 85,90 C75,110 80,150 85,180 L90,280 L80,380" />
        ) : (
          // Generic AP Outline
          <path d="M100,30 C120,30 130,50 130,70 L150,80 L140,150 L130,130 L130,200 L140,300 L140,380 M100,30 C80,30 70,50 70,70 L50,80 L60,150 L70,130 L70,200 L60,300 L60,380" />
        )}
        {/* Head circle */}
        <circle cx="100" cy="30" r="20" />
      </svg>
    </div>
  );
};

export default GhostOverlay;

